import styled from 'styled-components';
import Box from '@material-ui/core/Box';
import { getStyle } from 'globalutils/fmUtils';

const Wrapper = styled(Box)`
  ${({ theme }) => `
  min-height: calc(100vh - 77px);
  .viewReport{
    color: ${theme.colors.LINK_COLOR};
   text-decoration:none;
    &:hover {
      text-decoration: underline;
    }
  }

  .statusIcon {
    .MuiAvatar-root {
      width: 36px !important;
      height: 36px !important;
      svg {
        width: 30px !important;
        height: 32px !important;
      }
    }
  }

  .tabs {
    .MuiTab-wrapper {
      font-size: 22px;
      text-transform: capitalize !important;
    }
    .MuiTabs-flexContainer {
    @media (max-width: ${theme.breakpoints.values.md - 1}px) {
      flex-direction: row;
      text-align: -webkit-center;
    }
  }
    .MuiPaper-root.MuiAppBar-positionStatic {
      padding: 0px 1%;
      padding-top: 20px;
      background: transparent;
    }
    .MuiButtonBase-root.MuiTab-root {
      width:13%;
      min-width: auto;
      padding: 0;
      line-height: 1.3;
    }
    .MuiTypography-root {
      padding: 0 3%;
    }
    .MuiTableBody-root .MuiLink-root.MuiTypography-root{
      padding: 0;
    }
  }
  .tooltiptext {
    visibility: hidden;
    width: 100px;
    background: ${getStyle(
      '',
      (theme.palette.primary || {}).main,
      theme.colors.GREY_ONE
    )};
    color: ${theme.colors.WHITE};
    text-align: center;
    padding: 2px 0;
    border-radius: 0px;
    border: solid 1px ${theme.colors.WHITE};
    position: absolute;
    z-index: 1;
    right: 0;
    top: 35px !important;
    font-size: 15px;
  }
  .iconContainer:hover + .tooltiptext {
      visibility: visible;
    }
  }
  .iconContainer:first-child {
    margin-right: 8px;
  }
  .viewAll{
    display: flex;
    justify-content: flex-end;
    position: relative;
    padding-bottom: 10px;
    padding-top: 13px;
    .MuiGrid-container {
      width: auto;
      .MuiAvatar-root{
        width:32px
        height: 32px;

      }
    }
    .normalCheckbox span {
      padding: 0 5%;
    }
    .clearAll {
      margin-right: 10px;
    }
    .enable {
      width:30%;
      text-align: right;
    }
  }
  .seatbeathStatus {
    padding: 5px 18px;
    width: 156px;
    display: inline-block;
    text-align: center;
    font-size: 13px !important;
    color: ${theme.colors.WHITE};
  }
  .noData {
    background: ${theme.colors.GREY_DATA};
  }
  .notBuckled {
    background: ${theme.colors.RED};
  }
  .buckled {
    background: ${theme.colors.BUCKLED_GREEN};
  }
  .viewReportNewTab {
    cursor:pointer;
  }
  `}
`;

const HeaderWrapper = styled.ul`
  ${({ theme }) => `
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  margin-top: 0;
  width: 100%;
  margin-bottom: 0;
  border-left: 1px solid ${theme.colors.LIGHT_BORDER};
  padding: 0.4% 0.9%;
  padding-right: 0;
  background:  ${theme.colors.PRIMARY_MAIN};
  li {
    border-right: 1px solid ${theme.colors.LIGHT_BORDER};
    padding: 0 16px;
    flex: 1 0 auto;
    @media (max-width: ${theme.breakpoints.values.md - 1}px) {
      flex: 0 0 20%;
    }
    div:first-child {
      color: ${theme.colors.GREY};
      font-size: 16px;
      font-weight: normal;
      @media (max-width: ${theme.breakpoints.values.md - 1}px) {
        font-size: 12px;
      }
    }
    div:last-child {
      color: ${theme.colors.WHITE};
      font-size: 26px;
      font-weight: bold;
      @media (max-width: ${theme.breakpoints.values.md - 1}px) {
        font-size: 14px;
      }
    }
  }
  a:hover {
    text-decoration: none;
  }

  .total {
    color: ${theme.colors.SECONDARY_MAIN} !important;
  }
  .noLink {
    color: ${theme.colors.PRIMARY_CONTRAST} !important;
  }
  `}
`;

const MapWrapper = styled.div``;
const SummarySection = styled.div`
  .spireonOnly {
    display: none;
  }
`;
const Styled = { Wrapper, HeaderWrapper, MapWrapper, SummarySection };

export default Styled;
